/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-21 16:44:55
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-02 15:30:26
 */
import {uploadImage,uploadVideoFile} from '@/api/common.js'
export async function uploadImg(file,modelName) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', modelName);
   let data = await uploadImage(formData).then((res)=>{
       return res.data;
    })
    return data;
}

export async function uploadVideo(file,modelName) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', modelName);
   let data = await uploadVideoFile(formData).then((res)=>{
       return res.data;
    })
    return data;
}